/**
 * base on library/Em/Entity/Db/Message.php
 */

export const MESSAGE_FROM_TYPE = {
  FROM_TYPE_ADMIN: 'admin',
  FROM_TYPE_GUEST: 'guest',
  FROM_TYPE_USER: 'user',
  FROM_TYPE_SYSTEM: 'system',
};

export const MESSAGE_TYPE = {
  TYPE_CONNECT: 'connect',
  TYPE_OTHER: 'other',
  TYPE_RESUME_REQUEST: 'resume-request',
  TYPE_CONNECT_ACCEPT: 'connect-accept',
  TYPE_INBOUNDS_REPLY: 'inbounds-reply',
  TYPE_RECRUITER_SEARCH: 'recruiter-search',
  TYPE_RECRUITER_SEARCH_OTHER: 'recruiter-search-other',
  TYPE_RECRUITER_MEETING: 'recruiter-meeting',
  TYPE_REVIEW_APPEAL: 'review-appeal',
  TYPE_PROCESS_SETUP_EMAIL: 'process-setup-email',
  // candidate notifications
  TYPE_CANDIDATE_NOTIFY_INTERVIEW_DATA: 'notify-candidate-interview-data',
  TYPE_CANDIDATE_NOTIFY_REVIEW_OVERVIEW: 'notify-candidate-review-overview',
  TYPE_CANDIDATE_NOTIFY_REVIEW_INTERVIEW: 'notify-candidate-review-interview',
  TYPE_CANDIDATE_NOTIFY_REVIEW_EMPLOYEE: 'notify-candidate-review-employee',
  TYPE_CANDIDATE_NOTIFY_UPDATE_RESUME: 'notify-candidate-update-resume',
  TYPE_CANDIDATE_NOTIFY_GAT: 'notify-candidate-gat',
};

export const MESSAGE_FOLDER = {
  INBOX: 1,
  SENT: 2,
  INVITATIONS: 3,
  TRASH: 4,
};
